import React, { useEffect, useRef, useState } from "react";
import MessageComponent from "./MessageComponent";
import { Spinner } from "react-bootstrap";
import moment from "moment";
import { useSelector } from "react-redux";
import { BsTrash } from "react-icons/bs";
import dummmyImg from "../../../images/profile/images1.png";
import ConfirmModalLock from "../Modal/ConfirmModalLock";
import {
  getChatMediaLinks,
  resolveChatMessageType,
} from "./chatMessageType";

function getDeletedForCaption(item, userId, userName, selectedConversation) {
  const deletedFor = item?.deletedFor;
  if (!Array.isArray(deletedFor) || deletedFor.length === 0) return null;

  const otherId = selectedConversation?.otherPersonId;
  const otherName = selectedConversation?.otherPersonName;

  const nameForParticipantId = (id) => {
    const sid = String(id);
    if (String(item.sender) === sid) {
      return String(userId) === sid ? userName || "User" : otherName || "User";
    }
    if (String(item.receiver?._id) === sid) {
      return item.receiver?.name || otherName || "User";
    }
    if (String(userId) === sid) return userName || "User";
    if (String(otherId) === sid) return otherName || "User";
    return "User";
  };

  if (deletedFor.length === 1) {
    return `Deleted · ${nameForParticipantId(deletedFor[0])}`;
  }
  return "Both deleted";
}

function MessageListScroll({
  messageList,
  isChatFetching,
  userId,
  userName,
  onDeleteMessage,
}) {
  const bottomRef = useRef(null);
  const prevMessageListRef = useRef(messageList);
  const [pendingDeleteMessageId, setPendingDeleteMessageId] = useState(null);
  const [showDeleteMessageConfirm, setShowDeleteMessageConfirm] =
    useState(false);
  const selectedConversation = useSelector(
    (state) => state.session.selectedConversationDetails
  );

  function getMessageStyles(sender, senderType = "") {
    console.log(sender, "item", userId);
    if (sender === userId) {
      return {
        styles: {
          justifyContent: "flex-end",
        },
        isMyMessage: true,
      };
    } else {
      return {
        styles: {
          justifyContent: "flex-start",
        },
        isMyMessage: false,
      };
    }
  }
  function isProfilePicShown(fromId, senderType) {
    if (!getMessageStyles(fromId, senderType).isMyMessage) {
      return true;
    } else return false;
  }

  function checkIsFirstInTheSeries(fromIdLastMessage, index, senderType) {
    if (index === 0) return true;
    else {
      let secondLastMessage = messageList[index == 0 ? index : index - 1];
      if (secondLastMessage.sender === fromIdLastMessage) {
        if (secondLastMessage?.senderType == senderType) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
  }

  useEffect(() => {
    const prev = prevMessageListRef.current;
    const next = messageList ?? [];

    const getMsgKey = (m) => m?._id || m?.localMessageId;
    const prevKeys = new Set((prev ?? []).map(getMsgKey).filter(Boolean));
    const prevLen = (prev ?? []).length;
    const nextLen = next.length;

    const looksLikeRemovalOnly =
      prevLen > 0 &&
      nextLen < prevLen &&
      next.every((m) => prevKeys.has(getMsgKey(m)));

    prevMessageListRef.current = next;

    if (looksLikeRemovalOnly) {
      return;
    }

    const timeoutId = setTimeout(() => {
      bottomRef?.current?.scrollIntoView({ behavior: "smooth", block: "end" });
    }, 0);

    return () => clearTimeout(timeoutId);
  }, [messageList]);

  const renderDateSeparator = (date) => (
    <div className="message-date-separator">
      <div className="date-line">
        <span className="date-text">{moment(date).format("MMMM D, YYYY")}</span>
      </div>
    </div>
  );

  const groupMessagesByDate = (messages) => {
    const groups = {};
    messages.forEach((message) => {
      const date = moment(message.messageTime).format("YYYY-MM-DD");
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(message);
    });
    return groups;
  };

  const handleOpenInNewTab = () => {
    const url = `/user-details?data=${selectedConversation.otherPersonId}`;
    window.open(url, "_blank");
  };

  return (
    <div className="message-list-scroll">
      <ConfirmModalLock
        open={showDeleteMessageConfirm}
        title="Delete Message"
        description="Are you sure you want to delete this message?"
        confirmText="Delete"
        cancelText="Cancel"
        onCancel={() => {
          setShowDeleteMessageConfirm(false);
          setPendingDeleteMessageId(null);
        }}
        onConfirm={() => {
          if (!pendingDeleteMessageId) return;
          onDeleteMessage?.(pendingDeleteMessageId);
          setShowDeleteMessageConfirm(false);
          setPendingDeleteMessageId(null);
        }}
      />
      {messageList?.length > 0 &&
        (() => {
          const groupedMessages = groupMessagesByDate(messageList);
          return Object.entries(groupedMessages).map(([date, messages]) => (
            <React.Fragment key={date}>
              {renderDateSeparator(date)}
              {messages.map((item, index) => {
                const deletedCaption = getDeletedForCaption(
                  item,
                  userId,
                  userName,
                  selectedConversation
                );
                const resolvedType = resolveChatMessageType(item);
                const { mediaLink, bubbleLink } = getChatMediaLinks(item);
                return (
                <div
                  key={item._id || item?.localMessageId}
                  style={getMessageStyles(item.sender, item?.senderType).styles}
                  className={`d-flex align-items-start  gap-2 ${
                    isProfilePicShown(item.sender, item?.senderType) &&
                    !checkIsFirstInTheSeries(
                      item.sender,
                      index,
                      item?.senderType
                    ) &&
                    "ml-5"
                  }`}
                >
                  {isProfilePicShown(item.sender, item?.senderType) &&
                    checkIsFirstInTheSeries(
                      item.sender,
                      index,
                      item?.senderType
                    ) && (
                      <img
                        src={
                          selectedConversation?.otherPersonImage?.url
                            ? "" +
                              selectedConversation?.otherPersonImage?.url
                            : dummmyImg
                        }
                        onClick={handleOpenInNewTab}
                        alt=""
                        className="message-header_image pointer"
                      />
                    )}
                  <div className="d-flex align-items-start gap-1 position-relative message-row-wrapper">
                    <MessageComponent
                      key={item?._id || item?.localMessageId}
                      type={resolvedType}
                      documentLink={item?.documentLink}
                      text={item.message}
                      isMyMessage={
                        getMessageStyles(item?.sender, item?.senderType)
                          .isMyMessage
                      }
                      createdAt={item.messageTime}
                      isLocalMessage={item?._id ? false : true}
                      mediaLink={mediaLink}
                      bubbleLink={bubbleLink}
                      deletedCaption={deletedCaption}
                    />
                    {item?._id && onDeleteMessage && (
                      <button
                        type="button"
                        className="btn btn-sm btn-link text-danger p-1 message-delete-btn"
                        onClick={() => {
                          setPendingDeleteMessageId(item._id);
                          setShowDeleteMessageConfirm(true);
                        }}
                        title="Delete message"
                        aria-label="Delete message"
                      >
                        <BsTrash size={14} />
                      </button>
                    )}
                  </div>
                </div>
                );
              })}
            </React.Fragment>
          ));
        })()}
      {isChatFetching && (
        <div className="d-flex align-items-center justify-content-center">
          <Spinner animation="border" variant="info" />{" "}
        </div>
      )}
      <div className="pb-3" ref={bottomRef}></div>
    </div>
  );
}

export default MessageListScroll;
